/* eslint-disable multiline-ternary */
import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import { ActionButton } from '../../../../../../../../components'
import useAccountInfo from '../../../../hooks/useAccountInfo'
import { useSubscription } from '../../../../hooks/useSubscription'
import { useStyles } from './style'

const Discount = () => {
  const { accountInfo } = useAccountInfo()
  const { handleRedeemCoupon } = useSubscription()
  const classes = useStyles()
  if (!accountInfo?.retentionCoupon || !accountInfo?.retentionCoupon?.coupon || accountInfo?.trial) return null

  const { retentionCoupon: { discount, coupon, subscriptionId } } = accountInfo
  return (
    <Box className={classes.container}>
      <Typography variant='body' className={classes.headerTitle}>We consider you a valuable member so here is a last offer</Typography>
      <Card variant='outlined'>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Box className={classes.iconContainer}>
                <Typography className={classes.percentIcon}>
                  <span>%</span>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={10} lg={6}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant='h5' className={classes.title}>Keep learning for less</Typography>
                  <Divider orientation='horizontal' className={classes.divider} />
                </Grid>
                <Grid item xs={12}>
                  <Typography data-test='retension-discount-text' variant='subtitle2' className={classes.subtitle}>Get a <span className={classes.discount}>{discount} %</span> discount on all your payments for life</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={4} className={classes.buttonContainer}>
              <ActionButton
                variant='primary'
                size='m'
                label='Accept offer'
                data-test='retension-accept-discount'
                className={classes.button}
                onClick={() => {
                  handleRedeemCoupon({ coupon_code: coupon, subscriptionId: subscriptionId })
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}

export default Discount
